import clsx from "clsx";
import styles from "./SectionCard.module.scss";
import html from "remark-html";
import { remark } from "remark";
import cn from "clsx";
import splitSentenceByChar from "@/api/splitSentenceByChar";
import Markdown from "@/components/atoms/Markdown";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { ModalTypes } from "@/types/modal";

export default async function SectionCard({
  className,
  Title,
  Subtitle,
  SubTitle,
  Heading,
  isCard,
  CTA,
  children,
  isTopCTA,
  wide,
  isMobile,
  id,
  isStrike,
  hideHr,
  rootClassName,
  isSplitSubtitle = true,
  isGenericEvent = false,
  isCampusImmersionPage = false,
  isReferralPage = false,
  isLandings = false,
  webEngageEvent = {},
  isHomePage = false,
  isCareerPage = false,
}: any) {
  // const { isMobile } = usePageContext();

  const Hed = Title || Heading;
  const title = Hed?.enabled
    ? (
      await remark().use(html).process(Hed.text?.replace(/\n/gi, "  \n"))
    ).toString()
    : null;

  const Sub = Subtitle || SubTitle;

  let subTitle: any;
  if (isSplitSubtitle) {
    subTitle = Sub?.enabled ? splitSentenceByChar(Sub.text) : [];
  } else {
    subTitle = Sub?.enabled ? Sub?.text : "";
  }

  const cta = CTA?.enabled ? (
    <CommonButton
      GADataNew={{
        'event': isGenericEvent ? "generic_cta_click" : "view_all_cta_click",
        'cta_text': CTA.text,
        'section_name': title.replace(/<\/?[^>]+(>|$)/g, ""),
        isPageType: true
      }}
      webEngageEvent={webEngageEvent}
      isEventOnly
      href={CTA?.url}
      CTATarget={CTA?.target?.[0]}
      type={CTA?.url === '#' ? "button" : "link"}
      modalType={CTA?.url === '#' ? ModalTypes.RegistrationForm : null}
      className={styles.ctaBtn}
      icon="/_a/icons/left-arrow.svg"
      hoverIcon="/_a/icons/left-arrow-white.svg"
      bg="o"
      color="b"
    >
      {CTA.text}
    </CommonButton>
  ) : null;

  return (
    <section id={id} className={`${className}`}>
      <div className="container" style={isCampusImmersionPage ? { padding: 0, background: "#1a325d", color: "#fff" } : isReferralPage ? { padding: 0 } : isCareerPage ? { padding: 0 } : {}}>
        <div
          className={clsx(
            isLandings ?
              styles.lproot :
              styles.root,
            {
              [styles.card]: isCard,
              [styles.wide]: wide,
              [styles.campusImmersion]: isCampusImmersionPage
            },
            rootClassName,
          )}
        >
          {title ? (
            isHomePage ? (
              <h2
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: title.replace(/<\/?p[^>]*>/g, '') }}
              />
            ) : (
              <Markdown
                as="h2"
                className={styles.title}
              >
                {title.replace(/<\/?p[^>]*>/g, '')}
              </Markdown>
            )
          ) : null}
          {isStrike && !isCampusImmersionPage ? (
            <hr className="h-[1px] flex-1 lg:ml-4 lg:mt-5" />
          ) : null}
          {cta && isTopCTA && !isMobile ? (
            cta
          ) : subTitle[0] && (
            <>
              <p
                className={cn(styles.subtitle, "hidden", {
                  ["lg:block"]: Array.isArray(subTitle),
                  ["!text-left !m-0"]: isHomePage
                })}
              >
                {subTitle[0]} {isHomePage ? "" : <br />}
                {subTitle[1]}
              </p>
              <Markdown as="p"
                className={cn(styles.subtitle, "block", {
                  ["lg:hidden"]: Array.isArray(subTitle),
                  ["!text-left"]: isHomePage
                })}
              >
                {Sub.text?.replace(/\n/gi, "  \n")}
              </Markdown>
            </>
          )}
          {!hideHr && title && !isStrike ? <div className={styles.hr} /> : null}
          {!wide &&
            (title?.length > 0 ? (
              <div className="pt-7 lg:pt-7"><h2>{children}</h2   ></div>
            ) : (
              <>{children}</>
            ))}
          {cta && !isTopCTA && !wide ? (
            <div className={styles.cta}>{cta}</div>
          ) : null}
        </div>
      </div>
      {wide && (
        <div className="overflow-x-hidden pt-7 lg:pt-7 mb-6 lg:mb-14 wide-container">
          {children}
        </div>
      )}
      {wide && cta && (!isTopCTA || isMobile) ? (
        <div className={cn(styles.cta, styles.ctaBottom)}>{cta}</div>
      ) : null}
    </section>
  );
}
